module.exports = __webpack_public_path__ + "57f7802f41bc9e4e15bba5164f542c0a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/trees/roots.png
// module id = 3688
// module chunks = 0